export const plans = [
  {
    id: 'free' as const,
    name: 'Free',
    featureHeader: 'Use Anara for free with:',
    features: [
      '1000 AI words / day',
      '5 uploads / day',
      '1 recording / day',
      '120 pages or 20 MB per upload',
    ],
    cta: 'Choose Free',
  },
  {
    id: 'pro' as const,
    name: 'Pro',
    featureHeader: 'Everything in Free, and:',
    features: [
      'Unlimited AI words',
      'Unlimited uploads',
      'Unlimited recordings',
      'Access to premium models built on Claude 3.5, GPT 4.1, o4, DeepSeek R1 and Gemini 2.5',
      '10,000 pages or 300MB per upload',
      'Priority customer support',
    ],
    cta: 'Choose Pro',
  },
  {
    id: 'team' as const,
    name: 'Team',
    featureHeader: 'Everything in Pro, and:',
    features: [
      'Add team members',
      'Collaborative editing and chat',
      'Shared workspace',
      'Admin panel',
      'Dedicated account manager',
    ],
    cta: 'Choose Team',
  },
];

export type Plan = (typeof plans)[number];

export const prices = {
  AUD: {
    symbol: '$',
    Pro: {
      Monthly: { Price: 30.0, Total: 30.0 },
      Yearly: { Price: 18.0, Total: 216.0 },
    },
    Premium: {
      Monthly: { Price: 45.0, Total: 45.0 },
      Yearly: { Price: 27.0, Total: 324.0 },
    },
    Team: {
      Monthly: { Price: 45.0, Total: 45.0 },
      Yearly: { Price: 27.0, Total: 324.0 },
    },
  },
  CAD: {
    symbol: '$',
    Pro: {
      Monthly: { Price: 27.0, Total: 27.0 },
      Yearly: { Price: 16.2, Total: 194.4 },
    },
    Premium: {
      Monthly: { Price: 40.0, Total: 40.0 },
      Yearly: { Price: 24.0, Total: 288.0 },
    },
    Team: {
      Monthly: { Price: 40.0, Total: 40.0 },
      Yearly: { Price: 24.0, Total: 288.0 },
    },
  },
  CHF: {
    symbol: '₣',
    Pro: {
      Monthly: { Price: 18.0, Total: 18.0 },
      Yearly: { Price: 10.8, Total: 129.0 },
    },
    Premium: {
      Monthly: { Price: 27.0, Total: 27.0 },
      Yearly: { Price: 16.2, Total: 194.4 },
    },
    Team: {
      Monthly: { Price: 27.0, Total: 27.0 },
      Yearly: { Price: 16.2, Total: 194.4 },
    },
  },
  CNY: {
    symbol: '¥',
    Pro: {
      Monthly: { Price: 145.0, Total: 145.0 },
      Yearly: { Price: 87.0, Total: 1044.0 },
    },
    Premium: {
      Monthly: { Price: 217.0, Total: 217.0 },
      Yearly: { Price: 130.2, Total: 1562.4 },
    },
    Team: {
      Monthly: { Price: 217.0, Total: 217.0 },
      Yearly: { Price: 130.2, Total: 1562.4 },
    },
  },
  EUR: {
    symbol: '€',
    Pro: {
      Monthly: { Price: 18.0, Total: 18.0 },
      Yearly: { Price: 10.8, Total: 130.0 },
    },
    Premium: {
      Monthly: { Price: 28.0, Total: 28.0 },
      Yearly: { Price: 16.8, Total: 201.6 },
    },
    Team: {
      Monthly: { Price: 28.0, Total: 28.0 },
      Yearly: { Price: 16.8, Total: 201.6 },
    },
  },
  GBP: {
    symbol: '£',
    Pro: {
      Monthly: { Price: 16.0, Total: 16.0 },
      Yearly: { Price: 9.6, Total: 115.0 },
    },
    Premium: {
      Monthly: { Price: 24.0, Total: 24.0 },
      Yearly: { Price: 14.4, Total: 172.8 },
    },
    Team: {
      Monthly: { Price: 24.0, Total: 24.0 },
      Yearly: { Price: 14.4, Total: 172.8 },
    },
  },
  HKD: {
    symbol: '$',
    Pro: {
      Monthly: { Price: 156.0, Total: 156.0 },
      Yearly: { Price: 93.6, Total: 1123.0 },
    },
    Premium: {
      Monthly: { Price: 234.0, Total: 234.0 },
      Yearly: { Price: 140.4, Total: 1684.8 },
    },
    Team: {
      Monthly: { Price: 234.0, Total: 234.0 },
      Yearly: { Price: 140.4, Total: 1684.8 },
    },
  },
  JPY: {
    symbol: '¥',
    Pro: {
      Monthly: { Price: 3135.0, Total: 3135.0 },
      Yearly: { Price: 1881.0, Total: 22572.0 },
    },
    Premium: {
      Monthly: { Price: 4706.0, Total: 4706.0 },
      Yearly: { Price: 2823.6, Total: 33883.2 },
    },
    Team: {
      Monthly: { Price: 4706.0, Total: 4706.0 },
      Yearly: { Price: 2823.6, Total: 33883.2 },
    },
  },
  NZD: {
    symbol: '$',
    Pro: {
      Monthly: { Price: 33.0, Total: 33.0 },
      Yearly: { Price: 19.8, Total: 237.0 },
    },
    Premium: {
      Monthly: { Price: 49.0, Total: 49.0 },
      Yearly: { Price: 29.4, Total: 352.8 },
    },
    Team: {
      Monthly: { Price: 49.0, Total: 49.0 },
      Yearly: { Price: 29.4, Total: 352.8 },
    },
  },
  SGD: {
    symbol: '$',
    Pro: {
      Monthly: { Price: 27.0, Total: 27.0 },
      Yearly: { Price: 16.2, Total: 194.0 },
    },
    Premium: {
      Monthly: { Price: 40.0, Total: 40.0 },
      Yearly: { Price: 24.0, Total: 288.0 },
    },
    Team: {
      Monthly: { Price: 40.0, Total: 40.0 },
      Yearly: { Price: 24.0, Total: 288.0 },
    },
  },
  USD: {
    symbol: '$',
    Pro: {
      Monthly: { Price: 20.0, Total: 20.0 },
      Yearly: { Price: 12.0, Total: 144.0 },
    },
    Premium: {
      Monthly: { Price: 30.0, Total: 30.0 },
      Yearly: { Price: 18.0, Total: 216.0 },
    },
    Team: {
      Monthly: { Price: 30.0, Total: 30.0 },
      Yearly: { Price: 18.0, Total: 216.0 },
    },
  },
  ZAR: {
    symbol: 'R',
    Pro: {
      Monthly: { Price: 367.0, Total: 367.0 },
      Yearly: { Price: 220.2, Total: 2642.0 },
    },
    Premium: {
      Monthly: { Price: 551.0, Total: 551.0 },
      Yearly: { Price: 330.6, Total: 3967.2 },
    },
    Team: {
      Monthly: { Price: 551.0, Total: 551.0 },
      Yearly: { Price: 330.6, Total: 3967.2 },
    },
  },
};
